import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import mixpanel from '../../utils/mixpanel';
import './ResellerDashboard.scss';
import ResellerDashboardLegacy from './ResellerDashboardLegacy';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { getDomoReport } from './domoReportActions';
import { getDomoEmbedData, getDomoReportErrorMessage } from './domoReportEntity';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';

export class ResellerDashboard extends Component {
    static propTypes = {
        embedData: PropTypes.shape({
            embedHtml: PropTypes.string
        }),
        errorMessage: PropTypes.string,
        flags: PropTypes.shape({
            resellerPhase1: PropTypes.bool
        }),
        onGetDomoReport: PropTypes.func
    };

    componentDidMount() {
        mixpanel.track('Reseller Dashboard page mounted');
        if (!this.props.embedData?.embedHtml) {
            this.props.onGetDomoReport();
        }
    }

    renderBoardingStatusSummaryHeader = () => {
        return (<div className="boarding-status-summary-widget-header">Path to Live</div>);
    };

    renderPortfolioOverview = () => {
        const { embedData, errorMessage } = this.props;

        if (errorMessage) {
            return (
                <div className="portfolio-overview-section">
                    <div className="portfolio-overview-card">
                        <div className="domo-error-message">Failed to load report</div>
                    </div>
                </div>
            );
        }

        return (
            <div className="portfolio-overview-section">
                <div className="portfolio-overview-card">
                    {this.props.embedData?.embedHtml ? (
                        <iframe
                            srcDoc={embedData?.embedHtml}
                            title="Domo Dashboard"
                            className="domo-embed-iframe"
                            height="100%"
                            width="100%"
                        />
                    ) : (
                        <LoadingSpinner relative />
                    )}
                </div>
            </div>
        );
    };

    render() {
        return this.props.flags?.resellerPhase1 ? (
            <div className="emvio-reseller-dashboard">
                {this.renderPortfolioOverview()}
                {/* Taking this out, but leaving here for now in case we need it later */}
                {/* {this.renderBoardingStatusSummaryHeader()} */}
                {/* <BoardingStatusSummaryWidget /> */}
            </div>
        ) : (
            <ResellerDashboardLegacy />
        );
    }
}

function mapStateToProps(state) {
    return {
        embedData: getDomoEmbedData(state),
        errorMessage: getDomoReportErrorMessage(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetDomoReport: () => dispatch(getDomoReport())
    };
}

export default withLDConsumer()(connect(mapStateToProps, mapDispatchToProps)(ResellerDashboard));
